import React from 'react';
import { motion } from 'framer-motion';
export function Bonuses() {
  const bonuses = [{
    num: '01',
    title: 'Empaquetado y Presentación Profesional',
    desc: 'Hacé que una creación hermosa se vea limpia, cuidada y premium para regalar o vender.',
    val: '$12.000'
  }, {
    num: '02',
    title: 'Marketing y Ventas Express',
    desc: 'Cómo tomar fotos irresistibles con tu celular y nombrar tus colecciones para vender en Instagram sin complicarte.',
    val: '$15.000'
  }, {
    num: '03',
    title: 'Alquimia de Aromas Comestibles',
    desc: 'El secreto para combinar aromas y sabores que despierten el apetito (sin esencias artificiales tóxicas).',
    val: '$10.000'
  }, {
    num: '04',
    title: 'Calculadora de Costos y Precios Justos',
    desc: 'Fijá valores con seguridad, sumando tus materiales y tu tiempo para asegurar más del 200% de ganancia.',
    val: '$15.000'
  }];
  return <section className="py-14 px-6 bg-brand-ivory" data-id="element-19">
      <div className="max-w-6xl mx-auto" data-id="element-20">
        <div className="text-center mb-10" data-id="element-21">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-choco-deep mb-4" data-id="element-22">
            🎁 4 BONOS ESTRATÉGICOS SIEMPRE INCLUIDOS
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-23">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-brand-gold/20 relative overflow-hidden" data-id="element-24">
              <div className="absolute -right-4 -top-4 text-9xl font-serif font-bold text-brand-cream/50 select-none z-0" data-id="element-25">
                {bonus.num}
              </div>
              <div className="relative z-10" data-id="element-26">
                <h3 className="text-xl font-bold text-brand-choco-deep mb-3" data-id="element-27">
                  🎁 BONO {bonus.num.replace('0', '')}: {bonus.title}
                </h3>
                <p className="text-brand-choco/80 mb-6" data-id="element-28">{bonus.desc}</p>
                <div className="inline-block bg-brand-cream px-4 py-2 rounded-lg font-bold text-brand-choco-deep" data-id="element-29">
                  <span className="line-through text-brand-choco/50 mr-2" data-id="element-30">
                    {bonus.val}
                  </span>
                  <span className="text-brand-burgundy" data-id="element-31">➔ GRATIS</span>
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-32">
          <p className="text-2xl font-serif font-bold text-brand-choco-deep bg-brand-gold/20 inline-block px-8 py-4 rounded-xl border border-brand-gold/30" data-id="element-33">
            Valor total de los bonos:{' '}
            <span className="line-through text-brand-choco/50" data-id="element-34">~$52.000~</span>{' '}
            <span className="text-brand-burgundy" data-id="element-35">
              ➔ GRATIS con tu MegaPack
            </span>
          </p>
        </div>
      </div>
    </section>;
}